import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { appointment } from "@solimat/solimat-web-endpoint";
import CalendarEmptyIcon from "../../../img/NewDesign/img/calendar-empty.svg?react";
import "./NextAppointmentNew.scss";
import useGetAllAppointmentsByUserId from "@/services/appointments/useGetAllAppointmentsByUserId";

interface NextAppointmentNewProps {
  userId?: string;
  userName?: string;
  onNav?: (section: string) => void;
}

const NextAppointmentNew: React.FC<NextAppointmentNewProps> = ({
  userId,
  userName = "Paciente",
  onNav,
}) => {
  // const [nextAppointment, setNextAppointment] = useState<INextAppointment>(EMPTY_APPOINTMENT);
  // const [resolved, setResolved] = useState(false);
  const { getNextAppointment, nextAppointment, hasAppt } = useGetAllAppointmentsByUserId();
  const navigate = useNavigate();
  useEffect(() => {
    getNextAppointment(userId); 
  }, [userId]);


  const getGreeting = () => {
    const h = new Date().getHours();
    if (h >= 6 && h < 14) return "Buenos días";
    if (h >= 14 && h < 20) return "Buenas tardes";
    return "Buenas noches";
  };

  const handleNav = (section: string) => {
    if (onNav) onNav(section);
    else navigate(`/${section}`);
  };

  const _fecha = nextAppointment.fecha ? new Date(nextAppointment.fecha) : null;
  const hour = _fecha
    ? _fecha.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
      }) + " h"
    : "";
  const date = _fecha
    ? _fecha.toLocaleDateString("es-ES", {
        weekday: "short",
        day: "numeric",
        month: "short",
      })
    : "";
  const centro = nextAppointment.linkVideoConsulta
    ? "Video Consulta"
    : nextAppointment.centro.descripcion || nextAppointment.centro.nombre;

  return (
    <section className="hero">
      <div className="container">
        <div className="hero__grid">
          {/* Greeting */}
          <div className="hero__greeting">
            <span className="eyebrow">{getGreeting()}</span>
            <h1>
              Hola, <em>{userName}</em>.<br />
              Aquí está tu día.
            </h1>
            <p>
              {hasAppt
                ? "Tu próxima cita está a la vuelta de la esquina. Si necesitas algo más, tu gestor está disponible."
                : "Hoy no tienes ninguna cita programada. Si quieres pedir una o tienes dudas, tu gestor está disponible."}
            </p>
            <div className="hero__greeting-actions">
              <button
                className="hero-btn hero-btn--outline"
                onClick={() => handleNav("comunicaciones")}
              >
                <span className="e-icons e-comment-show"></span>
                Contactar gestor
              </button>
            </div>
          </div>

          {/* Appointment card */}
          <div className={`hero__appt${hasAppt ? "" : " hero__appt--empty"}`}>
            {hasAppt ? (
              <>
                <div className="hero__appt-eyebrow">Próxima cita</div>
                <div className="hero__appt-title">
                  {nextAppointment.especialidad || nextAppointment.nombrePrueba}
                </div>
                <div className="hero__appt-list">
                  <div className="hero__appt-item">
                    <div className="k">Fecha</div>
                    <div className="v">{date}</div>
                  </div>
                  <div className="hero__appt-item">
                    <div className="k">Hora</div>
                    <div className="v">{hour}</div>
                  </div>
                  <div className="hero__appt-item">
                    <div className="k">Centro</div>
                    <div className="v">{centro}</div>
                  </div>
                  <div className="hero__appt-item">
                    <div className="k">Dr.</div>
                    <div className="v">{nextAppointment.doctor.nombre}</div>
                  </div>
                </div>
                <div className="hero__appt-actions">
                  <button
                    className="hero-btn hero-btn--white"
                    onClick={() => handleNav(`mis-citas/${nextAppointment.id}`)}
                  >
                    Ver detalles
                  </button>
                  {/*                   <button className="hero-btn hero-btn--ghost" onClick={() => handleNav('mis-citas')}>Reprogramar</button>
                   */}{" "}
                </div>
              </>
            ) : (
              <div className="hero__appt-empty-content">
                <div className="hero__appt-eyebrow">Sin citas próximas</div>
                <div className="hero__appt-emptyglyph" aria-hidden>
                  <CalendarEmptyIcon
                    width={64}
                    height={64}
                    aria-hidden="true"
                  />
                </div>
                <div className="hero__appt-emptytitle">
                  No tienes citas programadas
                </div>
                <div className="hero__appt-emptysub">
                  Cuando tu gestor agende una nueva cita aparecerá aquí. Si
                  quieres pedir una o tienes dudas, tu gestor está disponible.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NextAppointmentNew;
